import React from 'react';
import {Tag, BgMedia, ButtonWrapper, BgImg} from '../../elements';
import {
    HeaderWrapper,
    TitleImgWrap,
    BottomContent,
    ButtonContainer,
    Credits
} from './Header.styles';
import {BackgroundProps, ButtonProps, TagProps} from 'epic-ue-shared';

interface Header {
    titleImg: string;
    desc?: string;
    type?: string;
    buttons?: ButtonProps[];
    tag?: TagProps;
    background: BackgroundProps;
    credits?: string;
}

export const HeaderTitleImage = ({
    titleImg,
    desc,
    tag,
    type,
    buttons,
    background = {} as any,
    credits
}: Header): JSX.Element => {
    let height = '90vh';
    if (type === 'slim') {
        height = '50vh';
    }
    return (
        <HeaderWrapper
            customHeight={height}
            className={`header header-title-img header-${type} center`}>
            <BgMedia autoplay={true} background={background} />
            <div className="container-fluid">
                <div className="row">
                    <TitleImgWrap className="container">
                        <BgImg img={titleImg} />
                    </TitleImgWrap>
                    <BottomContent>
                        {tag ? <Tag type="overlay" content={tag.content}/> : <div />}
                        <div className="copy" dangerouslySetInnerHTML={{__html: desc || ''}} />
                        <ButtonContainer>
                            <ButtonWrapper buttons={buttons} />
                        </ButtonContainer>
                    </BottomContent>
                </div>
            </div>
            <Credits>{credits || ''}</Credits>
        </HeaderWrapper>
    );
};
